// extracted by mini-css-extract-plugin
module.exports = {"container":"Popup_container__3gkqT","popUpOverlay":"Popup_popUpOverlay__cjsgG","noOnClose":"Popup_noOnClose__vWuc1","popUpContainer":"Popup_popUpContainer__Do9_X"};